import React from 'react';
import { PageModelLayout } from 'src/components/molecules/PageModelLayout';
import { DAKeyMetrics } from 'src/features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from 'src/components/organisms/FilterBar';
import { Channels } from 'src/features/DA/components/templates/Channels';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const ChannelsPage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Channels"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <Channels />
    </PageModelLayout>
  );
};
